var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4477 18.7353C22.6396 18.6498 22.8444 18.6489 23.0226 18.7174C23.2009 18.7858 23.3525 18.9235 23.4379 19.1154L25.5733 23.9115L11.8701 30.0125L9.73474 25.2164C9.64933 25.0246 9.64843 24.8197 9.71685 24.6415C9.78527 24.4632 9.923 24.3116 10.1148 24.2262L22.4477 18.7353Z",
    stroke: "#00805B",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8882 23.9524C22.4558 23.6997 22.7111 23.0347 22.4584 22.4671C22.2057 21.8995 21.5407 21.6442 20.9731 21.8969C20.4054 22.1496 20.1502 22.8146 20.4029 23.3822C20.6556 23.9498 21.3206 24.2051 21.8882 23.9524Z",
    fill: "#00805B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20833 14.7061L5.93578 14.3961C5.21152 14.2999 4.51731 14.7321 4.28474 15.4267C4.04382 16.1579 4.24234 16.9726 4.79936 17.5046L11.1582 23.6549L21.7302 18.948C21.5617 16.3384 20.931 13.7786 19.8664 11.3874L19.3753 10.2843",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25976 14.8225L4.59913 6.60063C4.27883 5.88121 4.60192 5.03953 5.32133 4.71923C5.34189 4.71008 5.36929 4.69787 5.38985 4.68872C6.17553 4.38817 7.06217 4.75693 7.40383 5.5243L10.1493 11.6907",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0294 13.6711L9.47365 10.1767C9.15944 9.47103 9.47493 8.64915 10.1806 8.33495C10.2149 8.31969 10.2423 8.30749 10.2766 8.29224C11.0752 8.00234 11.958 8.381 12.3027 9.15523L13.7701 12.4508",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8202 12.5608L12.8257 10.3272C12.5054 9.60778 12.8285 8.7661 13.5479 8.44579C13.5685 8.43664 13.5959 8.42444 13.6164 8.41529C14.4021 8.11474 15.2887 8.48349 15.6304 9.25087L16.5578 11.3337",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4533 11.0998L16.255 10.6544C15.9256 9.91445 16.2562 9.05296 16.9962 8.72351C17.0099 8.71741 17.0236 8.7113 17.0305 8.70825C17.8002 8.3902 18.6875 8.7422 19.0292 9.50958L19.3007 10.1194",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 30.6309L15.9617 28.1904",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.1d19ce57c8c093ded2aede0df6fb476b.svg";
export { ForwardRef as ReactComponent };